export class Pair<T, U> {

  constructor(public first: T, public second: U) {
  }
}
